import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ForgotPassword } from '../views/ForgotPassword/ForgotPassword'
import { ResetPassword } from '../views/ResetPassword/ResetPassword'
import { ResetPasswordVerifyToken } from '../views/ResetPassword/ResetPasswordVerifyToken'
import { Signin } from '../views/Signin/Signin'

const router = createBrowserRouter([
  {
    path: '/signin',
    element: <Signin />,
  },
  {
    path: '/forgot_password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset_password/:token',
    element: <ResetPasswordVerifyToken />,
  },
  {
    path: '/reset_password',
    element: <ResetPassword />,
  },
])

export const Routes: React.FC = () => {
  return <RouterProvider router={router} />
}
